import(/* webpackMode: "eager" */ "/home/ec2-user/project-pulse/frontend/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/project-pulse/frontend/app/src/components/AppLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/project-pulse/frontend/app/src/components/AppProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/project-pulse/frontend/app/src/components/ClientErrorBoundary.tsx");
